import { render } from "./PdfBatch.vue?vue&type=template&id=56741692&scoped=true"
import script from "./PdfBatch.vue?vue&type=script&lang=js"
export * from "./PdfBatch.vue?vue&type=script&lang=js"

import "./PdfBatch.vue?vue&type=style&index=0&id=56741692&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56741692"]])

export default __exports__